// Maps an LTL carrier name (from a quote/route) to a brand logo URL.
// Uses Clearbit's public logo endpoint (no key). If a carrier isn't mapped or the
// logo 404s, the caller falls back to the generic LTL truck icon.

// keyword (lowercased, matched as substring) -> primary domain
const CARRIER_DOMAINS = [
  ["fedex", "fedex.com"],
  ["r+l", "rlcarriers.com"],
  ["r&l", "rlcarriers.com"],
  ["rl carriers", "rlcarriers.com"],
  ["globaltranz", "globaltranz.com"],
  ["priority1", "priority1.com"],
  ["priority 1", "priority1.com"],
  ["warp", "wearewarp.com"],
  ["estes", "estes-express.com"],
  ["xpo", "xpo.com"],
  ["saia", "saia.com"],
  ["old dominion", "odfl.com"],
  ["odfl", "odfl.com"],
  ["arcbest", "arcb.com"],
  ["abf", "abfs.com"],
  ["tforce", "tforcefreight.com"],
  ["yellow", "myyellow.com"],
  ["yrc", "myyellow.com"],
  ["averitt", "averittexpress.com"],
  ["southeastern", "sefl.com"],
  ["sefl", "sefl.com"],
  ["aaa cooper", "aaacooper.com"],
  ["ward", "wardtlc.com"],
  ["dayton", "daytonfreight.com"],
  ["pitt ohio", "pittohio.com"],
  ["pitt-ohio", "pittohio.com"],
  ["roadrunner", "rrts.com"],
  ["central transport", "centraltransport.com"],
  ["ups", "ups.com"],
  ["cross country", "crosscountryfreight.com"],
  ["dependable", "godependable.com"],
  ["forward air", "forwardair.com"],
  ["new penn", "newpenn.com"],
  ["holland", "hollandregional.com"],
  ["reddaway", "reddawayregional.com"],
];

export function carrierDomain(name) {
  const n = (name || "").toLowerCase().trim();
  if (!n) return null;
  for (const [kw, domain] of CARRIER_DOMAINS) {
    if (n.includes(kw)) return domain;
  }
  return null;
}

export function carrierLogoUrl(name) {
  const domain = carrierDomain(name);
  // Google's favicon service: reliable, no API key, returns the brand mark (redirects to gstatic).
  // The <img> onerror in the marker/card falls back to the LTL truck if this fails.
  return domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=64` : null;
}
